<template>
  <div class="session">
    <container>
      <header>
        <h2>Noter <span class="save color-tint" v-if="!requesting" @click="save">Gem</span></h2>
      </header>
      <text 
        v-if="notes || team" 
        v-show="!saving" 
        :initial-text="notes"
        @value="setText">
      </text>
      <loader v-if="requesting || saving"></loader>
    </container>
  </div>
</template>

<script>
import view from '../mixins/view'
import Text from '../components/Text'
import api from 'api'
import { http } from 'api/resources'
import Loader from 'components/Loader'

export default {
  name: 'Notes',
  mixins: [view],
  components: {
    Text,
    Loader
  },
  data () {
    return {
      requesting: true,
      saving: false,
      text: null
    }
  },
  methods: {
    setText (text) {
      this.text = text
    },
    save () {
      this.saving = true
      http.put(`me/teams/${this.id}`, JSON.stringify(this.request))
      .then(response => {
        this.saving = false
        console.log('%csaved note', 'font-weight: bold; color: green', response)
      })
    }
  },
  computed: {
    id () {
      return parseInt(this.$route.params.team)
    },
    request () {
      return {
        notes: this.text
      }
    },
    notes () {
      return this.team && this.team.notes
    }
  },
  asyncComputed: {
    team () {
      return api.getTeams()
      .then(response => response.data)
      .then(teams => teams.find(team => {
        this.requesting = false
        return team.id === this.id
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  margin-bottom: 4rem;
}
.text {
  min-height: 20rem;
}
.save {
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }
}
</style>


// WEBPACK FOOTER //
// Notes.vue?9202749e